import { render, staticRenderFns } from "./futer.vue?vue&type=template&id=550cbbd9&scoped=true"
import script from "./futer.vue?vue&type=script&lang=js"
export * from "./futer.vue?vue&type=script&lang=js"
import style0 from "./futer.vue?vue&type=style&index=0&id=550cbbd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550cbbd9",
  null
  
)

export default component.exports